import { styled } from '@arpeggi/ui'
import { FC, PropsWithChildren, useState } from 'react'
import { Link } from 'react-router-dom'
import GlobalPlayer from '../../__legacy__/components/platform/global-player/GlobalPlayer'
import { MintSoundModal } from '../../__legacy__/components/studio/mint/upload-sound-modal/MintSoundModal'
import { ProfileCard } from './components'
import { Logo, Navbar } from './primitives'

const Base = styled('div', {
  paddingTop: '64px',
  fontFamily: 'DM Sans',
  minHeight: '100vh'
})

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false)
  return (
    <Base>
      <Navbar.Root>
        <Navbar.Menu>
          <Navbar.Start>
            <Logo.Root as={Link} to={'/home'}>
              <Logo.Icon />
              <Logo.Text>Arpeggi Studio</Logo.Text>
            </Logo.Root>
            <Navbar.List>
              <Navbar.Item>
                <Navbar.Link asChild>
                  <Link to="/home">Home</Link>
                </Navbar.Link>
              </Navbar.Item>
              <Navbar.Item>
                <Navbar.Trigger>
                  Samples
                  <Navbar.Caret aria-hidden />
                </Navbar.Trigger>
                <Navbar.Content>
                  <Navbar.SubList css={{ width: '300px' }}>
                    <Navbar.ListItem to="/sounds" title="Samples">
                      Browse and download from an ever growing library of sounds!
                    </Navbar.ListItem>
                    <Navbar.ListItem to="/packs" title="Packs">
                      Find sample packs by emerging creators
                    </Navbar.ListItem>
                    <Navbar.ListItemLink as="div" onClick={() => setOpen(true)}>
                      <Navbar.ListItemHeading>Upload</Navbar.ListItemHeading>
                      <Navbar.ListItemText>
                        Upload your own sounds and get attribution!
                      </Navbar.ListItemText>
                    </Navbar.ListItemLink>
                  </Navbar.SubList>
                </Navbar.Content>
              </Navbar.Item>
              <Navbar.Item>
                <Navbar.Link asChild>
                  <Link to="/studio">Studio</Link>
                </Navbar.Link>
              </Navbar.Item>
              <Navbar.Item>
                <Navbar.Link asChild>
                  <a href="https://docs.arpeggi.io/faq" target="_blank">
                    Learn
                  </a>
                </Navbar.Link>
              </Navbar.Item>
              <Navbar.ViewportPosition>
                <Navbar.Viewport />
              </Navbar.ViewportPosition>
            </Navbar.List>
          </Navbar.Start>
          <Navbar.End>
            <ProfileCard />
          </Navbar.End>
        </Navbar.Menu>
      </Navbar.Root>
      {children}
      <GlobalPlayer />
      <MintSoundModal open={open} onOpenChange={setOpen} />
    </Base>
  )
}
